module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "gas-station.2e7bba4c.png";